//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getResult } from '@/api/jfhl'
export default {
  data () {
    return {
      list: []
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  mounted () {
    this.getResult()
  },
  methods: {
    getResult () {
      getResult({
        accountid: this.accountid
      }).then(res => {
        this.list = res.obj
      })
    }
  }
}
